/* jshint esversion: 6, -W097, -W040 */
/* globals require, module */
'use strict';

/**
 * Ad Slot Directive
 *
 * Configures an ad slot and gets an AppNexus ad (if enabled), or a Native Ad (if AppNexus is not
 * enabled and Native Ads are). If no ads are enabled, then the directive's contents remain empty.
 *
 * @module enervee_utils.ads
 */

function adSlotDirective() {
    return {
        restrict: 'E',
        scope: {
            tagname: '@',
            appNexusNoStyle: '<?',
            appNexusisMobile: '<?',
            appNexusisDesktop: '<?',
            nativeAdCategoryId: '<?',
            categoryCode: '<?',
            showTagEvent: '@?',
            adLoaded: '=?',
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: adSlotController,
        template: require('./adSlotView.html'),
    };
}

adSlotController.$inject = [
    'AdService',
    'AppNexusService',
    'NativeAdsService',
    'GoogleAdService',
];
function adSlotController(
    AdService,
    AppNexusService,
    NativeAdsService,
    GoogleAdService
) {
    this.$onInit = function () {
        const vm = this;

        vm.appNexusEnabled = AppNexusService.isEnabled;
        // Native Ads should only be enabled if AppNexus and GoogleAds are _not_ enabled
        vm.nativeAdsEnabled = NativeAdsService.isEnabled;
        // Native Ads should only be enabled if AppNexus is _not_ enabled
        vm.googleAdsEnabled = GoogleAdService.isEnabled;
        vm.adsEnabled = AdService.adsEnabled;
    };
}

module.exports = adSlotDirective;
